// API配置文件
export const isProduction = process.env.NODE_ENV === 'production'
// export const isProduction = true
// 判断是否为开发环境
export const isDev = process.env.NODE_ENV === 'development'

// API基础URL配置
// 获取当前域名并根据域名选择对应的API地址
const getCurrentApiBaseUrl = () => {
  if (isDev) {
    return '/' // 开发环境使用代理路径
  }
  
  // 生产环境根据当前域名选择API地址
  const currentHostname = window.location.hostname
  
  if (currentHostname === 'hello-gpt.com') {
    return 'https://api.hello-gpt.com'
  }
  
  // 默认使用 trangpt.ai 的API
  return 'https://trangpt.ai'
}

export const apiBaseUrl = getCurrentApiBaseUrl()

// 其他配置
export const config = {
  // 请求超时时间
  timeout: 10000,
  
  // 是否携带凭证
  withCredentials: true,
  
  // 成功状态码
  successCode: ['200', 200, 0, '0', 'ok', 'true']
}

// 联系方式配置
export const contactTelegramUrl = 'https://t.me/TranGPT666'
// WhatsApp 联系方式（留空则不显示）
export const contactWhatsappUrl = 'https://wa.me/447353239682'

export const turnstileSiteKey = '0x4AAAAAAAPWZUF_0v1lvAlZ'

// Stripe 配置
// 生产环境和测试环境的 Stripe 可发布密钥
export const stripePublishableKey = isProduction
  ? 'pk_live_51QHbmtKwhE5a2mmjzipfLsoAYVOb3rqt4c8Xr9EAtXbo9vhONOt7tZZhGO2IPsWLNmnCpOsYPthGz5cgwPzM302t007fXG5VpJ' // 生产环境
  : 'pk_test_51Rq5EZDzhoWKypwLfxYMsKDJAy4Yxphbjx2AqvJ4Gsif0VLrFGPngUV7si8hhDbFyepPTQqG4gbPyPELjlxe3pZ900NZTMYPkc' // 测试环境
